import styled from "styled-components"

export const StyledFooterSection = styled.section`
  width: 100%;
`
